interface Props {
  showOnFaqPage: boolean;
}

/**
 * Two-state pill mirroring the blog/landing status pills. Sage when
 * the FAQ is visible on the public /faq page, muted grey when it's
 * landing-page-only (hidden from the global FAQ list).
 */
export function FaqStatusPill({ showOnFaqPage }: Props) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[11px] font-medium ${
        showOnFaqPage
          ? "text-sage [&_.dot]:bg-sage"
          : "text-ink-4 [&_.dot]:bg-ink-5"
      }`}
    >
      <span className="dot inline-block h-[6px] w-[6px] rounded-full" />
      {showOnFaqPage ? "On FAQ page" : "Landing only"}
    </span>
  );
}
